import React from 'react';
import './Hero.css';

const Hero = ({ onRegisterClick }) => {
  return (
    <section className="hero">
      <div className="hero-background">
        <div className="gradient-overlay"></div>
        <div className="pattern-overlay"></div>
      </div>

      <div className="hero-container">
        {/* Top section with flags and date */}
        <div className="hero-top-section">
          <div className="hero-flags">
            <div className="flag-item" title="USA">
              <svg viewBox="0 0 60 30" className="flag">
                <clipPath id="s"><path d="M0,0 v30 h60 v-30 z"/></clipPath>
                <clipPath id="t"><path d="M30,15 h30 v15 z v15 h-30 z h-30 v-15 z v-15 h30 z"/></clipPath>
                <g clipPath="url(#s)">
                  <path d="M0,0 v30 h60 v-30 z" fill="#bd3d44"/>
                  <path d="M0,3.69 h60 M0,11.08 h60 M0,18.46 h60 M0,25.85 h60" stroke="#fff" strokeWidth="2.46"/>
                  <path d="M0,0 v16.15 h24 v-16.15 z" fill="#192f5d"/>
                  <g fill="#fff">
                    <path d="M2,2 h2 v2 h-2 z M6,2 h2 v2 h-2 z M10,2 h2 v2 h-2 z M14,2 h2 v2 h-2 z M18,2 h2 v2 h-2 z M22,2 h2 v2 h-2 z"/>
                    <path d="M4,4 h2 v2 h-2 z M8,4 h2 v2 h-2 z M12,4 h2 v2 h-2 z M16,4 h2 v2 h-2 z M20,4 h2 v2 h-2 z"/>
                    <path d="M2,6 h2 v2 h-2 z M6,6 h2 v2 h-2 z M10,6 h2 v2 h-2 z M14,6 h2 v2 h-2 z M18,6 h2 v2 h-2 z M22,6 h2 v2 h-2 z"/>
                    <path d="M4,8 h2 v2 h-2 z M8,8 h2 v2 h-2 z M12,8 h2 v2 h-2 z M16,8 h2 v2 h-2 z M20,8 h2 v2 h-2 z"/>
                    <path d="M2,10 h2 v2 h-2 z M6,10 h2 v2 h-2 z M10,10 h2 v2 h-2 z M14,10 h2 v2 h-2 z M18,10 h2 v2 h-2 z M22,10 h2 v2 h-2 z"/>
                    <path d="M4,12 h2 v2 h-2 z M8,12 h2 v2 h-2 z M12,12 h2 v2 h-2 z M16,12 h2 v2 h-2 z M20,12 h2 v2 h-2 z"/>
                  </g>
                </g>
              </svg>
            </div>
            <div className="flag-item" title="Australia">
              <svg viewBox="0 0 1280 640" className="flag">
                <rect width="1280" height="640" fill="#012169"/>
                <g id="canton">
                  <path d="M0,0 v55.95 l307.037,194.05 h38.647 v-55.95 L38.647,0 z" fill="#FFF"/>
                  <path d="M345.684,0 v55.95 L38.647,250 H0 v-55.95 L307.037,0 z" fill="#FFF"/>
                  <path d="M144.035,0 v250 h57.614 V0 z" fill="#FFF"/>
                  <path d="M0,83.333 v83.333 h345.684 V83.333 z" fill="#FFF"/>
                  <path d="M0,100 v50 h345.684 v-50 z" fill="#C8102E"/>
                  <path d="M155.558,0 v250 h34.568 V0 z" fill="#C8102E"/>
                  <path d="M0,250 l115.228,-83.334 h25.765 L25.765,250 z" fill="#C8102E"/>
                  <path d="M0,0 l115.228,83.333 H89.463 L0,18.633 z" fill="#C8102E"/>
                  <path d="M204.69,83.333 L319.92,0 h25.764 L230.456,83.333 z" fill="#C8102E"/>
                  <path d="M345.685,250 l-115.228,-83.334 h25.765 L345.685,231.367 z" fill="#C8102E"/>
                </g>
                <g id="star1" transform="translate(240, 440)">
                  <polygon points="0,-60 17.5,-18 62,-18 25,-10 42,32 0,2 -42,32 -25,-10 -62,-18 -17.5,-18" fill="#FFF"/>
                </g>
                <g id="star2" transform="translate(915, 140)">
                  <polygon points="0,-48 14,-14 50,-14 20,-8 34,26 0,2 -34,26 -20,-8 -50,-14 -14,-14" fill="#FFF"/>
                </g>
                <g id="star3" transform="translate(1000, 75)">
                  <polygon points="0,-48 14,-14 50,-14 20,-8 34,26 0,2 -34,26 -20,-8 -50,-14 -14,-14" fill="#FFF"/>
                </g>
                <g id="star4" transform="translate(1000, 240)">
                  <polygon points="0,-48 14,-14 50,-14 20,-8 34,26 0,2 -34,26 -20,-8 -50,-14 -14,-14" fill="#FFF"/>
                </g>
                <g id="star5" transform="translate(930, 320)">
                  <polygon points="0,-48 14,-14 50,-14 20,-8 34,26 0,2 -34,26 -20,-8 -50,-14 -14,-14" fill="#FFF"/>
                </g>
                <g id="star6" transform="translate(815, 260)">
                  <polygon points="0,-30 8.75,-8.75 31.25,-8.75 12.5,-5 17,16 0,1 -17,16 -12.5,-5 -31.25,-8.75 -8.75,-8.75" fill="#FFF"/>
                </g>
              </svg>
            </div>
            <div className="flag-item" title="United Kingdom">
              <svg viewBox="0 0 60 30" className="flag">
                <rect width="60" height="30" fill="#012169"/>
                <path d="M0,0 l60,30 M60,0 l-60,30" stroke="#fff" strokeWidth="6"/>
                <path d="M0,0 l60,30 M60,0 l-60,30" stroke="#C8102E" strokeWidth="4"/>
                <path d="M30,0 v30 M0,15 h60" stroke="#fff" strokeWidth="10"/>
                <path d="M30,0 v30 M0,15 h60" stroke="#C8102E" strokeWidth="6"/>
              </svg>
            </div>
          </div>

          {/* Date badge at top right */}
          <div className="hero-badge">
            <span className="badge-dot"></span>
            <span>30-Oktyabr | 20:00</span>
          </div>
        </div>

        {/* Main title/question */}
        <h1 className="hero-title">
          Qanday qilib Amerika, Angliya va Avstraliya davlatlarida yuqori scholarship olib ta'lim olish mumkin?
        </h1>

        {/* Description box */}
        <div className="description-box">
          <p className="hero-description">
            Xorijda o'qish imkoniyatlari, grant dasturlari va qabul jarayoni haqida to'liq ma'lumot
          </p>
        </div>

        {/* Speaker image with overlay button */}
        <div className="speaker-image-section">
          <img
            src="/images/web.webp"
            alt="Mentor"
            className="speaker-image"
          />
          {/* CTA Button overlay */}
          <button className="cta-button cta-overlay" onClick={onRegisterClick}>
            <span className="button-text">MASTERCLASSDA ISHTIROK ETISH</span>
          </button>
        </div>

        {/* Expert heading */}
        <h2 className="expert-heading">MENTOR HAQIDA</h2>

        {/* Speaker info box */}
        <div className="speaker-info-box">
          <h3 className="speaker-name">G'ayratjon Akbarov</h3>
          <ul className="speaker-details">
            <li>Londonliklar Consulting kompaniyasi asoschisi</li>
            <li>Ko'p yillik xalqaro ta'lim sohasidagi tajriba</li>
            <li>100+ talabani xorijiy universitetlarga muvaffaqiyatli jo'natgan</li>
          </ul>
        </div>

        {/* Bonus section */}

        <div className="bonus-badge">
          <div className="bonus-icon">🎁</div>
          <div className="bonus-content">
            <h3 className="bonus-title">MAXSUS BONUS</h3>
            <p className="bonus-description">Masterclassda qatnashganlar uchun maxsus bonus</p>
          </div>
        </div>

        {/* Final CTA Button */}
        <button className="cta-button cta-final" onClick={onRegisterClick}>
          <span className="button-text">BEPUL RO'YXATDAN O'TISH</span>
        </button>
      </div>
    </section>
  );
};

export default Hero;
